import type { Post } from "~/types";

export default function usePosts() {
	const posts = ref<Post[]>([]);
	const isLoading = ref(false);
	const { $pb } = useNuxtApp();

	const loadPosts = async () => {
		isLoading.value = true;
		try {
			const result = await $pb.collection("posts").getFullList<Post>({
				sort: "-created",
			});
			posts.value = result || [];
		} catch (error) {
			console.error("Error loading posts:", error);
		} finally {
			isLoading.value = false;
		}
	};

	onMounted(loadPosts);

	return { posts, isLoading, loadPosts };
}
